module.exports = __webpack_public_path__ + "static/media/ecuador.d4dcf221.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ecuador.svg
// module id = 112
// module chunks = 0